const Diamond = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.12073 1.19817C2.21013 1.07459 2.36323 1 2.5275 1H9.57463C9.7429 1 9.89913 1.07823 9.9874 1.20669L11.9279 4.03053C12.0344 4.18554 12.022 4.38365 11.8967 4.52693L6.38152 10.8335C6.28962 10.9386 6.14894 11 6 11C5.85106 11 5.71038 10.9386 5.61847 10.8335L0.103325 4.52693C-0.0245135 4.38074 -0.0346554 4.17787 0.0780831 4.02202L2.12073 1.19817ZM2.79091 1.86957L1.37727 3.82385H3.77451L4.26928 1.86957H2.79091ZM5.26365 1.86957L4.76888 3.82385H7.25009L6.826 1.86957H5.26365ZM7.81388 1.86957L8.23798 3.82385H10.6469L9.3039 1.86957H7.81388ZM10.5188 4.69341H8.21278L7.05979 8.64878L10.5188 4.69341ZM6 8.84605L7.2105 4.69341H4.7895L6 8.84605ZM3.78722 4.69341L4.94021 8.64878L1.48122 4.69341H3.78722Z"
      fill="#EEC23D"
    />
  </svg>
);

export default Diamond;
